import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import PageHeader from 'components/ui/page_header';

export default function Header({ modelName, templateName, saving, saveDisabled, onCancel, onSave }) {
  return (
    <PageHeader containerWidth>
      <PageHeader.Heading description={templateName} title={`Edit ${modelName}`} />
      <PageHeader.Actions>
        <Button disabled={saving || saveDisabled} label="Save" type="button" onClick={onSave} />
        <Button disabled={saving} label="Cancel" type="button" variant="ghost" onClick={onCancel} />
      </PageHeader.Actions>
    </PageHeader>
  );
}

Header.propTypes = {
  modelName: PropTypes.string.isRequired,
  saveDisabled: PropTypes.bool,
  saving: PropTypes.bool,
  templateName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
